import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import "./Form.css"


const Form = () => {
  return (
    <div><nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
    <img src="/logo.png" alt="logo" />
    <h5 className="mb-0">
      <span>SVT</span><br />
      DIGITAL INFO TECH
    </h5>

    {/* Toggler Button */}
    <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

    {/* Collapse menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
       <Link className="nav-link" to="/">
  <i className="fa-solid fa-house"></i> HOME
</Link>
        </li>

        <li className="nav-item dropdown">
        <Link
  className="nav-link dropdown-toggle"
  to="#"
  id="navbarDropdownMenuLink"
  role="button"
  data-bs-toggle="dropdown"
  aria-expanded="false"
>
  <i className="fa-solid fa-desktop"></i> SERVICES
</Link>

          <ul
            className="dropdown-menu p-3 custom-dropdown"
            aria-labelledby="navbarDropdownMenuLink"
            style={{ minWidth: '600px' }}
          >
            <div className="row">
              <div className="col-6">
<li>
  <Link className="dropdown-item" to="/website">
    <i className="fa-solid fa-desktop"></i> Website
  </Link>
</li>               <li>
  <Link className="dropdown-item" to="/graphicwork">
    <i className="fa-solid fa-fire"></i> Graphic Work
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/ecommerce">
    <i className="fa-solid fa-cart-shopping"></i> Ecommerce Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/software">
    <i className="fa-solid fa-tv"></i> Software Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/business">
    <i className="fa-solid fa-chart-line"></i> Business Consulting
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/erp">
    <i className="fa-solid fa-computer"></i> ERP Software
  </Link>
</li>
              </div>
              <div className="col-6">
               <li>
  <Link className="dropdown-item" to="/search">
    <i className="fa-solid fa-rocket"></i> Search Engine Optimization
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/digitalmarketing">
    <i className="fa-solid fa-satellite-dish"></i> Digital Marketing
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/socialmedia">
    <i className="fa-brands fa-hubspot"></i> Social Media Management
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/lead">
    <i className="fa-solid fa-network-wired"></i> Lead Generation
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/businessbrand">
    <i className="fa-solid fa-tag"></i> Business Branding
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/hr">
    <i className="fa-brands fa-searchengin"></i> HR Services
  </Link>
</li>
              </div>
            </div>
          </ul>
        </li>

        <li className="nav-item">
        <Link className="nav-link" to="/about">
  <i className="fa-solid fa-circle-info"></i> ABOUT US
</Link>
        </li>

        <li className="nav-item">
      <Link className="nav-link" to="/form">
  <i className="fa-solid fa-address-book"></i> CONTACT
</Link>
        </li>

      </ul>
    </div>
  </div>
</nav>


<div className='heading'>
 <h4>Contact Us</h4>
 <h5>Any question or remarks? Just write us a message!</h5>
    <div className="container mt-5 mb-5">
      <div className="row shadow rounded overflow-hidden">
        {/* Left Contact Info Panel */}
        <div className="col-md-5 bg-primary text-white p-4">
          <h4>Contact Information</h4>
          <p>Say something to start and reach us</p>
          <ul className="list-unstyled">
            <li className="mb-3"><FaPhoneAlt />  &nbsp;  9961828591, 9365473531</li>
            <li className="mb-3"><FaEnvelope /> &nbsp;  svtdigiinfo@gmail.com</li>
            <li className="mb-3"><FaMapMarkerAlt /> &nbsp; Kongu main road, MS nagar new bus stand, Tiruppur - 641 607</li>
          </ul>
          <div className="d-flex gap-3 mt-4">
            <a href="#" className="text-white"><FaFacebookF /></a>
            <a href="#" className="text-white"><FaInstagram /></a>
            <a href="#" className="text-white"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Right Form Panel */}
        <div className="col-md-7 bg-white p-4">
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="First Name" />
              </div>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Last Name" />
              </div>
              <div className="col-md-6 mb-3">
                <input type="email" className="form-control" placeholder="Email" />
              </div>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Phone Number" />
              </div>
              <div className="col-12 mb-3">
                <select className="form-select">
                  <option>Select Services?</option>
                  <option>Website Design</option>
                  <option>SEO</option>
                  <option>Social Media Marketing</option>
                </select>
              </div>
              <div className="col-12 mb-3">
                <textarea className="form-control" rows="4" placeholder="Write your message.."></textarea>
              </div>
              <div className="col-12 mb-3 small">
                <p>
                  I agree to the terms & conditions and privacy policy and I am giving my consent to receive updates through SMS / Email
                </p>
              </div>
              <div className="col-12">
                <button type="submit" className="btn btn-success px-4">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
</div>
    </div>
  );
};

export default Form;
